<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item">Profile</router-link>
            <router-link to="/orders" class="item">Orders</router-link>
            <router-link v-if="isOfferEnabled" to="/offers" class="item"
              >My Offers</router-link
            >
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-table" v-if="$parent.offerHistory">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title small">My Offers</div>
              <button
                class="button new-offer-button"
                @click="$parent.openSaleSkinModal"
              >
                New offer
              </button>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- $parent.orderHistory -->
                    <tr v-for="(item, i) in $parent.offerHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.date_time) }}</td>
                      <td>{{ item.title }}</td>
                      <td>
                        {{ item.service_price || item.user_price }}
                        {{ item.currency }}
                      </td>
                      <td>{{ getStatusText(item.status) }}</td>
                      <td>
                        <a
                          class="offer-modal-open"
                          @click="$emit('openOfferDetailsModal', item)"
                          >View</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "SellOffers",
  props: ["isOfferEnabled"],
  components: {},
  data: function () {
    return {};
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    getStatusText(status) {
      const statusMap = {
        pending: "Pending Review",
        offer: "Offer Available",
        awaiting_item: "Awaiting Item",
        ready_for_payout: "Ready for Payout",
        payout_processing: "Payout Processing",
        approved: "Completed",
        declined_by_user: "Declined by You",
        declined_by_service: "Declined by Service",
      };
      return statusMap[status] || status;
    },
  },
  mounted() {},
  watch: {
    isOfferEnabled(newValue) {
      if (newValue === false && this.$route.name !== "Profile") {
        this.$router.replace({ name: "Profile" });
      }
    },
  },
};
</script>
